import type { FailReasonValues, NextStep } from '@repo/common';

import { FailReason } from '@repo/common';

export function getFailReason(step: NextStep): FailReasonValues {
  return step.failReason ?? FailReason.UNABLE_TO_VERIFY;
}
